import { useEffect, useState } from "react";
import { toast } from "sonner";

const STYLE = {
  live_ready: "bg-[#1E1E1E] text-[#F3F1EC] border-[#1E1E1E]",
  draft: "bg-[#FBE7D2] text-[#8a5a12] border-[#DB9130]",
  empty: "bg-transparent text-[#9A9A9A] border-dashed border-[#D3CFC0]",
};
const LABEL = { live_ready: "Live-ready", draft: "In progress", empty: "Not drafted" };

function LiveToggle({ api, sport, c, onDone }) {
  const go = async () => {
    const live = !c.live;
    const name = live ? window.prompt(`Type your name to approve ${sport} ${c.age} for LIVE sale:`) : "";
    if (live && !name) return;
    try { await api.post("/admin/starter-kit/live", { sport, age: c.age, live, approved_by: name || "" }); toast.success(live ? "Now Live" : "Set to Coming soon"); onDone(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  return <button data-testid={`sk-cov-live-${sport}-${c.age}`.toLowerCase().replace(/[^a-z0-9]+/g, "-")} onClick={go} className="underline">{c.live ? "Set coming soon" : "Approve Live"}</button>;
}

function Cell({ api, sport, c, onOpen, onPreview, onDone }) {
  const id = `${sport}-${c.age}`.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  return (
    <td className="p-1 align-top">
      <div data-testid={`sk-cov-cell-${id}`} className={`border-2 p-2 min-h-[92px] text-xs transition-transform hover:-translate-y-0.5 ${STYLE[c.status]}`}>
        <p className="font-head uppercase tracking-wide">{LABEL[c.status]}</p>
        {c.status !== "empty" && <p data-testid={`sk-cov-sale-${id}`} className={`mt-1 inline-block px-1.5 text-[10px] uppercase font-[IBM_Plex_Mono] ${c.live ? "bg-[#DB9130] text-[#1E1E1E]" : "border border-current"}`}>{c.live ? `Live · ${c.approved_by}` : "Coming soon"}</p>}
        {c.status !== "empty" && (
          <>
            <p className="font-[IBM_Plex_Mono] mt-1">{c.approved}/{c.items} approved</p>
            {c.founder_pending > 0 && <p>Founder pending: {c.founder_pending}</p>}
            {c.technique_pending > 0 && <p>Technique cues: {c.technique_pending}</p>}
            {c.betas > 0 && <p>Betas sent: {c.betas}</p>}
            {c.missing.length > 0 && <p className="mt-1 opacity-80" title={c.missing.join(", ")}>Missing: {c.missing.length} slot(s)</p>}
            <div className="flex gap-2 mt-2">
              <button data-testid={`sk-cov-open-${id}`} onClick={() => onOpen(sport, c.age)} className="underline">Items</button>
              <button data-testid={`sk-cov-preview-${id}`} onClick={() => onPreview(sport, c.age)} className="underline">Preview</button>
              <LiveToggle api={api} sport={sport} c={c} onDone={onDone} />
            </div>
          </>
        )}
      </div>
    </td>
  );
}

export default function CoverageGrid({ api, onOpen, onPreview }) {
  const [data, setData] = useState(null);
  const load = () => api.get("/admin/starter-kit/coverage").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);
  if (!data) return <p className="text-[#6E6E6E]">Loading coverage…</p>;
  return (
    <div className="overflow-x-auto" data-testid="sk-coverage-grid">
      <table className="w-full min-w-[640px] border-collapse">
        <thead>
          <tr>
            <th className="text-left text-xs font-[IBM_Plex_Mono] uppercase text-[#6E6E6E] p-1">Sport</th>
            {data.ages.map((a) => <th key={a} className="text-left text-xs font-[IBM_Plex_Mono] uppercase text-[#6E6E6E] p-1">Ages {a}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.rows.map((r) => (
            <tr key={r.sport}>
              <td className="p-1 pr-3 align-top">
                <p className="font-head uppercase text-sm text-[#1E1E1E]">{r.sport}</p>
                {r.second_reviewer && <p className="text-[10px] text-[#DB9130] uppercase">2nd reviewer required</p>}
              </td>
              {r.cells.map((c) => <Cell key={c.age} api={api} sport={r.sport} c={c} onOpen={onOpen} onPreview={onPreview} onDone={load} />)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
